import React from 'react'
import {Link} from 'react-router'
import {SideNav, SideNavHeader, SideNavExtras, SideNavActions, SideNavAction} from 'common/layouts/SideNavLayout/SideNav'
import {ProfileImg} from 'common/ProfileImg'
import cx from 'classnames'
import {LoadableOrganizations} from '../../Organizations'
import styles from './HomepageSideNav.scss'
import {currentUserHasPrivilege, DASH_LAUNCH} from 'lib/utils'
import {AccountTypeBadge} from 'common/AccountTypeBadge'

export const HomepageSideNav = ({user, collapseState}) => {
  const isMobile = collapseState === 'viewport' || collapseState === 'viewport-expanded'
  const legacyUser = user.createdAt < DASH_LAUNCH
  const home = (user.preferences && user.preferences.get('dashboard_home')) || 'dashboard'
  const pathParams = path => ({to: home === path ? '/' : `/${path}`, index: home === path})
  const canSeeRideCenter = currentUserHasPrivilege('activity_center')
  const links = [
    {title: 'Dashboard', ...pathParams('dashboard'), icon: 'md-home', id: 'dashboard-nav-home'},
    {title: isMobile ? 'Events' : 'Calendar', ...pathParams('calendar'), icon: 'md-calendar'},
    {title: 'Routes', ...pathParams('routes'), icon: 'md-pin'},
    {title: 'Rides', ...pathParams('rides'), icon: 'md-bicycle'},
    user.accountLevel === 11 && {title: 'Collections', ...pathParams('collections'), icon: 'dynamic-feed'},
    canSeeRideCenter
      ? {title: 'Analyze', href: '/activities', icon: 'md-trending-up', id: 'dashboard-nav-analyze'}
      : {title: 'Analyze', to: '/analyze', icon: 'md-trending-up', id: 'dashboard-nav-analyze'},
    {title: 'Upload', to: '/upload', icon: 'upload-arrow'},
    {title: 'Friends', ...pathParams('friends'), icon: 'md-people', id: 'dashboard-nav-friends'},
    {title: 'More', ...pathParams('more'), icon: 'md-apps', id: 'dashboard-nav-more'}
  ].filter(l => l)

  return <SideNav links={links}>
    <SideNavHeader>
      <div className={cx(styles.userCard, collapseState && styles.userCardCollapsed)}>
        <Link to={`/users/${user.id}`}>
          <ProfileImg
            sidebarHeader
            user={user}
            className={styles.profileImg} />
        </Link>
        {!collapseState && <h2 className={styles.displayName}>{user.name} <AccountTypeBadge accountLevel={user.accountLevel} size={14} /></h2>}
      </div>
    </SideNavHeader>

    <SideNavExtras>
      <LoadableOrganizations currentUser={user} collapsed={collapseState} />
    </SideNavExtras>

    <SideNavActions>
      {legacyUser && !collapseState && <SideNavAction id='dashboard-nav-classic-profile' href={`/users/${user.id}?beta=false`} label='Return to Classic Profile View' />}
    </SideNavActions>
  </SideNav>
}
